import { ReactNode } from 'react';

import { ModifyGuideTab } from '../modify-guide.types';
import { BulkModifyStakeholders } from './bulk-modify-stakeholders';
import { GrantImport } from './grant-import';
import { ImportSafes } from './import-safes';
import { ImportStakeholders } from './import-stakeholders';
import { StakeholderTermination } from './stakeholder-termination';
import { TemplatePreparation } from './template-preparation';

export const guides: Record<
  ModifyGuideTab,
  { guide: ReactNode; guideTitle: string; stepsTitles: { title: string }[] }
> = {
  [ModifyGuideTab.IMPORT_GRANTS]: {
    guideTitle: 'Bulk Grant Import guide',
    guide: <GrantImport />,
    stepsTitles: [
      {
        title: 'Open the Bulk Grant Import Blade',
      },
      {
        title: 'Download the Excel Template',
      },
      {
        title: 'Understanding the Excel Template',
      },
      {
        title: 'Fill in the Grant Details',
      },
      {
        title: 'Upload the Filled Template',
      },
    ],
  },
  [ModifyGuideTab.IMPORT_SAFES]: {
    guideTitle: 'SAFE import guide',
    guide: <ImportSafes />,
    stepsTitles: [
      {
        title: 'Open the SAFE Import Blade',
      },
      {
        title: 'Download the Excel Template',
      },
      {
        title: 'Understanding the Excel Template',
      },
      {
        title: 'Fill in the SAFE Details',
      },
      {
        title: 'Upload the Filled Template',
      },
    ],
  },
  [ModifyGuideTab.IMPORT_STAKEHOLDERS]: {
    guideTitle: 'Stakeholders Import Guide',
    guide: <ImportStakeholders />,
    stepsTitles: [
      {
        title: 'Open the Import Stakeholders Blade',
      },
      {
        title: 'Select Stakeholder Type',
      },
      {
        title: 'Download the Excel Template',
      },
      {
        title: 'Understanding the Excel File',
      },
      {
        title: 'Fill in the Stakeholders List',
      },
      {
        title: 'Upload the Filled Template',
      },
    ],
  },
  [ModifyGuideTab.MODIFY_STAKEHOLDERS]: {
    guideTitle: 'Bulk Modify Guide',
    guide: <BulkModifyStakeholders />,
    stepsTitles: [
      {
        title: 'Open the Bulk Modify Blade',
      },
      {
        title: 'Select Stakeholder Type',
      },
      {
        title: 'Download the Excel Template',
      },
      {
        title: 'Understanding the Excel File',
      },
      {
        title: 'Editing the Excel File',
      },
      {
        title: 'Upload the Updated File',
      },
    ],
  },
  [ModifyGuideTab.STAKEHOLDERS_TERMINATION]: {
    guideTitle: 'Stakeholder Termination Guide',
    guide: <StakeholderTermination />,
    stepsTitles: [
      {
        title: 'Select Stakeholders for Termination',
      },
      {
        title: 'New Stakeholder Type',
      },
      {
        title: 'Choose Termination Type',
      },
      {
        title: 'Set Termination Date',
      },
      {
        title: 'Set Last Vesting Date',
      },
      {
        title: 'Review Grant Information',
      },
      {
        title: 'Confirm Termination',
      },
    ],
  },
  [ModifyGuideTab.TEMPLATE_PREPARATION]: {
    guideTitle: 'Template Mapping Guide',
    guide: <TemplatePreparation />,
    stepsTitles: [
      {
        title: 'Before you start — key things to know',
      },
      {
        title: 'What is a template and how to work with it',
      },
      {
        title: 'Step 1 — Prepare your document',
      },
      {
        title: 'Step 2 — Map fields in CapQuest',
      },
      {
        title: 'What happens at document creation',
      },
      {
        title: 'Editing a template',
      },
    ],
  },
};
